// extracted by mini-css-extract-plugin
export default {"consentBanner":"ConsentBanner_consentBanner__KWp5u","button":"ConsentBanner_button__kb--E"};